export const getBrowserLang = (): string | null => {
  if (typeof navigator === "undefined") return null
  const lang = navigator?.language?.split("-")[0]
  if (["nl", "de"].includes(lang)) return lang
  return null
}
